import type { ReactElement, SVGProps } from "react";

export function PlayGlyphIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      aria-hidden
      {...props}
    >
      <path
        d="M1 1.8v10.4c0 .63.69 1.02 1.23.7l8.6-5.2a.82.82 0 0 0 0-1.4l-8.6-5.2A.82.82 0 0 0 1 1.8Z"
        fill="#fff"
        fillOpacity=".92"
      />
    </svg>
  );
}
